export default __webpack_public_path__ + "static/media/bg-11.189d0d01.webp";